var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"id":"fadelayer","value":_vm.isLoading}},[_c('v-row',[_c('v-col',[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])])],1),_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('h2',[_vm._v("Loading...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }